import React from 'react';
import { Link } from 'gatsby';

const Dropdown = ({ submenu, dropdown }) => {
  return (
    <div className={`menu-drawer ${dropdown ? 'open' : ''}`}>
      <ol
        className={`${
          submenu.length > 1 ? 'site-navigation__sub-menu-flex site-navigation__sub-menu' : 'site-navigation__sub-menu'
        }`}
      >
        {submenu.map(({ icon, title, pages }, index) => (
          <li key={`column-${index + 1}`} className={`${submenu.length > 1 ? 'site-navigation__column' : ''}`}>
            {title && (
              <h3>
                {icon}
                {title}
              </h3>
            )}
            <ol className="site-navigation__sub-sub-menu">
              {pages.map((item, id) => (
                <li className="site-navigation__menu-item" key={`main-navigation-sub-item-${Number(id)}`}>
                  {item?.slug ? (
                    <Link to={`/${item?.category?.slug ?? item.slug}`}>{item.title}</Link>
                  ) : (
                    <a href={item.link} {...(item.blank && { target: '_blank', rel: 'noopener noreferrer' })}>
                      {item.title}
                      {item.badge && <span className="badge">{item.badge}</span>}
                    </a>
                  )}
                  {item?.customContent}
                </li>
              ))}
            </ol>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Dropdown;
